import { render, staticRenderFns } from "./StructureStamp.vue?vue&type=template&id=f5a2887c&scoped=true"
import script from "./StructureStamp.vue?vue&type=script&lang=js"
export * from "./StructureStamp.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./StructureStamp.vue?vue&type=style&index=1&id=f5a2887c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a2887c",
  null
  
)

export default component.exports